module.exports = __webpack_public_path__ + "static/img/pitch_white.0c09fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_white.png
// module id = lp7q
// module chunks = 94